export function EmptyState({ title, hint }: { title: string; hint?: string }) {
  return (
    <div
      style={{
        padding: '48px 24px',
        textAlign: 'center',
        border: '1px dashed var(--border)',
        borderRadius: 'var(--radius-md)',
        color: 'var(--text-secondary)',
      }}
    >
      <div style={{ fontSize: 15, color: 'var(--text-primary)', marginBottom: 4 }}>{title}</div>
      {hint && <div style={{ fontSize: 13 }}>{hint}</div>}
    </div>
  )
}

export function PendingBackendNotice({ endpoint }: { endpoint: string }) {
  return (
    <div
      style={{
        fontSize: 12,
        color: 'var(--status-warning)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-sm)',
        padding: '6px 10px',
        marginBottom: 16,
        display: 'inline-block',
      }}
    >
      Datos de ejemplo — pendiente de conectar <code className="mono">{endpoint}</code>
    </div>
  )
}
